import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchVendorsParams {
  limit?: number;
  enabled?: boolean;
}

export const useFetchVendors = (params: UseFetchVendorsParams = {}) => {
  const { limit = 12, enabled = true } = params;

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/vendor", {
      params: {
        query: {
          page: typeof pageParam === "number" ? pageParam : 1,
          limit,
        },
      },
    });

    const error = response.error;
    if (error) throw error;
    return response.data;
  };

  const {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  } = useInfiniteQuery({
    queryKey: ["vendors", limit],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;
      if (pagination?.hasNextPage) return pagination.page + 1;
      return undefined;
    },
    enabled,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  };
};
